import { Avatar } from "@chakra-ui/avatar";
import { Button } from "@chakra-ui/button";
import { Input } from "@chakra-ui/input";
import { Badge, Box, Divider, Flex, Heading, Text } from "@chakra-ui/layout";
import { Textarea } from "@chakra-ui/textarea";
import { useToast } from "@chakra-ui/toast";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/authContext";
import theme from "../helpers/theme";

export const PostList = ({ isAdmin, clubRef }) => {
	const [posts, setPosts] = useState();
	const { currentUser } = useAuth();
	const toast = useToast();

	const postTitleRef = useRef();
	const postContentRef = useRef();

	const createNewPost = e => {
		e.preventDefault();

		const title = postTitleRef.current.value;
		const content = postContentRef.current.value;

		if (title.length < 3 || content.length < 3)
			return toast({
				description: "Please fill out all the fields",
				title: "Title or content too short",
				status: "error",
			});

		clubRef.collection("posts").add({
			title,
			content,
			author: {
				image: currentUser.photoUrl ?? "",
				name: currentUser.displayName,
			},
			created: Date.now(),
		});

		postTitleRef.current.value = "";
		postContentRef.current.value = "";
	};

	useEffect(() => {
		const unsubscribe = clubRef
			.collection("posts")
			.orderBy("created")
			.limit(50)
			.onSnapshot(posts => {
				const docs = posts.docs;
				const filteredDocs = docs.map(doc => doc.data());
				setPosts(filteredDocs.reverse());
			});
		return unsubscribe;
	}, [clubRef]);

	return (
		<Box w="100%">
			<form onSubmit={createNewPost}>
				<Box
					w="100%"
					bg="gray.100"
					p="1rem"
					rounded="lg"
					mb={10}
					textAlign="center"
				>
					<Flex
						flexDir={{ base: "column", lg: "row" }}
						justifyContent={{
							base: "center",
							lg: "flex-start",
						}}
						alignItems={{ base: "flex-start", lg: "center" }}
					>
						<Heading
							size="md"
							m={3}
							ml={{ base: 1, lg: 3 }}
							wordBreak="false"
							userSelect="none"
							whiteSpace="nowrap"
						>
							What's goin' on?
						</Heading>
						<Input
							rounded="full"
							border="none"
							focusBorderColor={theme.colours.accent + ".400"}
							bgColor="white"
							ref={postTitleRef}
							placeholder="Call the title sumn"
						/>
					</Flex>
					<Textarea
						rounded="xl"
						border="none"
						focusBorderColor={theme.colours.accent + ".400"}
						bgColor="white"
						placeholder="Say hi to ppl all over the world or just in your school idk im not context-aware! you can tell we don't use redux smh"
						ref={postContentRef}
						rows="3"
						mt={3}
					/>
					<Button
						focusBorderColor={theme.colours.accent + ".400"}
						colorScheme={theme.colours.accent}
						variant="ghost"
						type="submit"
						mt={3}
						w={{ base: "100%", lg: "auto" }}
					>
						Create New Post
					</Button>
				</Box>
			</form>

			{posts && posts.length !== 0 ? (
				posts.map((post, key) => (
					// <Tooltip
					// 	key={key}
					// 	userSelect="none"
					// 	label="I hover cus im cool :sunglasses:"
					// 	fontSize="xs"
					// 	openDelay={1000}
					// >
					<Box
						key={key}
						bgColor="gray.100"
						p="2rem 2rem 1rem 2rem"
						mb={8}
						rounded="lg"
						userSelect="none"
						cursor="pointer"
						transition="box-shadow 200ms"
						_hover={{ boxShadow: "0 2px 5px -1px gray" }}
					>
						{/* title */}
						<Heading size="md" mb={3}>
							{post.title}
						</Heading>
						<Text fontSize="md">{post.content}</Text>
						<Divider w="100%" colorScheme="red" size="xl" />
						{/* info about the creator */}
						<Flex mt="5" alignItems="center " color="gray.600">
							{/* image */}
							<Avatar size="md" mr={2} src={post.author.image} />
							<Text wordBreak={false} isTruncated={true} ml={3}>
								<strong>{post.author.name}</strong> •
							</Text>
							<Text ml={3}>
								{new Date(post.created).toLocaleDateString()}
							</Text>

							<Badge
								borderRadius="full"
								px="2"
								mr="2"
								colorScheme="teal"
								ml="5"
							>
								ur epic
							</Badge>
						</Flex>
					</Box>
					// </Tooltip>
				))
			) : (
				<Box w="100%" textAlign="center">
					<Heading size="md">No posts here yet :'(</Heading>
				</Box>
			)}
		</Box>
	);
};
